export default {
  title: 'Imagine ofertă',
  select: {
    generate_title: 'Generează o imagine cu AI',
    generate_subtitle: 'Vom crea una pe baza detaliilor ofertei tale.',
    generate_cta: 'Generează',
    upload_link: 'sau încarcă de pe dispozitivul tău',
    rate_limit_company: {
      title: 'Avem nevoie de un moment',
      description: 'Restaurantul tău a generat multe imagini în această oră. Încearcă din nou în {{time}}.',
    },
    rate_limit_offer: {
      title: 'O scurtă pauză',
      description: 'Se pare că ai încercat această ofertă de câteva ori la rând. Vom fi gata din nou în {{time}}.',
    },
  },
  generating: {
    title: 'Se generează imaginea…',
    progress: {
      cooking: 'Pregătim ceva delicios…',
      plating: 'Se finisează…',
      finishing: 'Se adaugă ultimele detalii…',
    },
  },
  preview: {
    alt: 'Imagine ofertă generată',
    hint: 'Nu e tocmai ce ai vrut? Regenerează sau continuă să editezi imaginea.',
    click_to_expand: 'Click pentru a extinde',
    regenerate: 'Regenerează',
    continue: 'Continuă editarea',
  },
  toasts: {
    upload_success: 'Imagine încărcată cu succes.',
    upload_failed: 'Încărcarea imaginii a eșuat.',
    delete_success: 'Imagine ștearsă cu succes.',
    delete_failed: 'Ștergerea imaginii a eșuat.',
    generate_success: 'Imagine generată cu succes.',
    generate_failed: 'Pornirea generării imaginii a eșuat.',
    generate_timeout: 'Imaginea este în curs de generare. Va apărea aici când va fi gata.',
    rate_limit_company: 'Limita orară de imagini atinsă pentru acest restaurant. Încearcă din nou în {{time}}.',
    rate_limit_offer: 'Prea multe încercări pentru această ofertă — încearcă din nou în {{time}}.',
  },
  time: {
    seconds_one: '1 secundă',
    seconds_few: '{{count}} secunde',
    seconds_other: '{{count}} secunde',
    minutes_one: '1 minut',
    minutes_few: '{{count}} minute',
    minutes_other: '{{count}} minute',
    hours_one: '1 oră',
    hours_few: '{{count}} ore',
    hours_other: '{{count}} ore',
  },
};
